// Экраны воронки оплаты по порядку. Между ними — анимированный сдвиг:
// вперёд по воронке — влево, назад — вправо. Остальные переходы приложения не анимируются.
const FLOW_STEPS = {
  Onboarding: 1,
  OnboardingTariffSelection: 2,
  SubscriptionTariffSelection: 2,
  OnboardingSubscriptionPayment: 3,
  SubscriptionPayment: 3,
  SubscriptionEditFullName: 4,
  SubscriptionEditEmail: 4,
  SubscriptionEditTelegram: 4,
}

/** Имя CSS-перехода для смены маршрута или null, если переход не анимируется */
export function resolveFlowTransition(toName, fromName) {
  const to = FLOW_STEPS[toName]
  const from = FLOW_STEPS[fromName]

  if (!to || !from || to === from) {
    return null
  }

  return to > from ? 'route-forward' : 'route-back'
}
